import React from "react";
import clsx from "clsx";

import { getDisplayValue } from "./helper";
import { useChartState } from "../useChartState";

import useStyles from "./styles";

export interface Props {
  value: number;
  capacity: number;
  className?: string;
  customValue?: string;
}

const Donut = (props: Props) => {
  const { value, capacity, className, customValue } = props;

  const classes = useStyles();
  const { percent, status } = useChartState(value, capacity);

  const displayValue = getDisplayValue(value, customValue);
  const shouldDecreaseFont = [!Number.isInteger(value), value > 999].some(
    Boolean
  );

  return (
    <>
      <div className={clsx(className, classes.donutChart)}>
        <svg viewBox="0 0 32 32" className={classes.donutSvg}>
          <circle
            className={clsx(classes.donutCircle, status)}
            style={{ strokeDasharray: `${percent} 100` }}
            r="16"
            cx="16"
            cy="16"
          />
        </svg>
        <div className={classes.donutChartCenter}>
          <span
            className={clsx(classes.donutChartCenterText, status, {
              [classes.decreasedFontSize]: shouldDecreaseFont
            })}
          >
            {displayValue}
          </span>
        </div>
      </div>
    </>
  );
};

export default Donut;
